import TextIframeBlock from './TextIframeBlock';

export default TextIframeBlock;
export * from './TextIframeBlock';
